<template>
  <div class="header__page">
    <h1 v-html="title" />

    <div class="buttons">
      <Button
        v-for="(button, i) in buttons"
        v-show="!button.hide"
        :key="'head' + i"
        :text="button.text"
        :icon="button.icon"
        width="100%"
        :iconWidth="button.iconWidth || '15px'"
        class="buttons__item"
        @click="button.event"
      />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    buttons: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.header__page {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 24px;

  .buttons {
    display: flex;
    white-space: nowrap;
    align-items: center;

    .buttons__item {
      color: $dark-blue;
      font-size: 16px;

      &:hover {
        color: $blue;
        fill: $blue;
      }
    }
  }
}
</style>
